export const MY_PAYMENTS = 'Moje płatności'
export const SHOW_ALL = 'Zobacz wszystkie'
export const MY_NEWS = 'Moje wiadomości'
export const MY_DOCS = 'Moje umowy'
export const SHOW_DETAILS = 'Zobacz szczegóły'
export const HIDE_DETAILS = 'Ukryj szczegóły'
export const CUSTOMER_DATA = 'Dane płatnika'
export const MORE_INFO = 'Więcej informacji'
export const HELLO_AGAIN = ' witaj ponownie!'
